<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    :width="width"
    :height="height"
    :class="direction"
  >
    <path
      v-if="weight === 'regular'"
      :fill="fillColor"
      d="M295.515 115.716l-19.626 19.626c-4.753 4.753-4.675 12.484.173 17.14L356.78 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h344.78l-80.717 77.518c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l131.799-131.799c4.686-4.686 4.686-12.284 0-16.971L312.485 115.716c-4.686-4.686-12.284-4.686-16.97 0z"
    />
    <path
      v-else
      :fill="fillColor"
      d="M254.544 154.427L320.118 220H24c-13.255 0-24 10.745-24 24v24c0 13.255 10.745 24 24 24h296.118l-65.574 65.573c-9.373 9.373-9.373 24.569 0 33.941l16.971 16.971c9.373 9.373 24.569 9.373 33.941 0L440.97 272.97c9.373-9.373 9.373-24.569 0-33.941L305.456 103.515c-9.373-9.373-24.569-9.373-33.941 0l-16.971 16.971c-9.373 9.372-9.373 24.568 0 33.941z"
    />
  </svg>
</template>

<script>
import Base from "@/components/icons/Base";
export default {
  name: "LongArrow",
  extends: Base,
  props: {
    weight: {
      type: String,
      default: "regular"
    },
    direction: {
      default: "right"
    }
  }
};
</script>

<style scoped lang="scss">
.left {
  transform: rotate(-180deg);
}
.right {
  margin-right: 0;
  margin-left: 5px;
}
</style>
